// statuses
export const pecrStatus = {
  Open: 1,
  LSC_Cancel: 2,
  LSC_Review: 3,
  SC_Reject: 4,
  SC_Hold: 5,
  SC_NotImpacted: 6,
  SC_Review: 7,
  SO_Hold: 8,
  SO_NotImpacted: 9,
  SO_Review: 10,
  Estimating: 11,
  Estimation_In_Process: 12,
  Estimated: 13,
  Estimated_Reject: 14,
  Estimated_Hold: 15,
  Submitted: 16,
  GC_Reject: 17,
  GC_Hold: 18,
  GC_Executing: 19,
  Execution_In_Process: 20,
  Executed: 21,
  Complete: 22,
  Summary_Cancel: 23,
  FR_Reject: 24,
};

// main folder for s3 bucket
export const pecrMainFolder = 'PECROverview';

export const DEFAULT_PECR_LIST_STATUS = [
  {
    Status: 'Rejected',
  },
  {
    Status: 'Hold',
  },
  {
    Status: 'Cancelled',
  },
  {
    Status: 'Preliminary review',
  },
  {
    Status: 'Site selection',
  },
  {
    Status: 'Owner selection',
  },
  {
    Status: 'Department selection',
  },
  {
    Status: 'Estimation Phase',
  },
  {
    Status: 'Review before execution',
  },
  {
    Status: 'Execution Phase',
  },
  {
    Status: 'Final Review',
  },
  {
    Status: 'Complete',
  },
];

export const DEFAULT_FILTERED_STATUS = DEFAULT_PECR_LIST_STATUS.map(status => {
  return {
    ...status,
    checked: status.Status !== 'Complete' && status.Status !== 'Cancelled',
  };
});
export const DEFAULT_SITE_LIST = [
  {
    SiteName: 'Charlotte',
  },
  {
    SiteName: 'Shanghai',
  },
  {
    SiteName: 'Montluel',
  },
  {
    SiteName: 'Culoz',
  },
  {
    SiteName: 'Montilla',
  },
  {
    SiteName: 'Hyderabad',
  },
];

export const DEFAULT_FILTERED_SITES = DEFAULT_SITE_LIST.map(site => {
  return {
    ...site,
    checked: true,
  };
});

// Version Number
export const PECR_VERSION_NUMBER = '1.11.0';
